export enum ChatbotAppearanceThemeType {
  curve = 'curve',
}
